import { render } from "./PrescriptionTab.vue?vue&type=template&id=497468e6"
import script from "./PrescriptionTab.vue?vue&type=script&lang=js"
export * from "./PrescriptionTab.vue?vue&type=script&lang=js"

import "./PrescriptionTab.vue?vue&type=style&index=0&id=497468e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__